import Email from "@mapmycustomers/shared/types/email/Email";

import { parseApiDate } from "@app/util/parsers";

const getEmailDate = (email: Email) => {
  return parseApiDate(email.date ? email.date : email.createdAt);
};

export default getEmailDate;
